import React from "react";
import { useGetAllAcademicPrices } from "../../../hooks/academicPrices/academicPrices.hooks";
import { ListTable } from "../../Table/listTable/listTable";
import { academicPricesTitles } from "../../../Constants/tableTitles/ListTableTitle/academicPrices.titles";
import { transformAcademicPricesTableData } from "../../../Services/transformer/transformAcademicPricesTransformer";

export const AcademicPricesLists = () => {
  const { isLoading: isAcademicPriceListLoading, data: academicPriceLists } =
    useGetAllAcademicPrices();

  return (
    <div>
      <ListTable
        titles={academicPricesTitles}
        data={academicPriceLists}
        isDataLoading={isAcademicPriceListLoading}
        transformFn={transformAcademicPricesTableData}
      />
    </div>
  );
};
